"use strict";
// TODO Refactor JavelinImpl: maybe unbind store, move helpers & getString
//      functionality to own file
// TODO Get browser-determined vals via constructor: deviceName, deviceModel,
//      platformVersion (eliminate use of mad-utils in this file)
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY IMPORTS ***************************************/
var mobx_1 = require("mobx");
var react_1 = require("mad-utils/lib/react");
/**************************************** PROJECT MODULES *****************************************/
var language_store_1 = require("./data/store/language-store");
var store_1 = require("./data/store/store");
var javelin_exports_1 = require("./javelin-exports");
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory("javelin-impl.ts", shared_1.Styles.theHeist, util_1.inspect);
/**************************************** TYPE DEFINITIONS ****************************************/
var keys = Object.keys;
var createRecordCallsCountTotal = 0;
/***************************************** IMPLEMENTATION *****************************************/
var JavelinImpl = /** @class */ (function () {
    /*** INSTANTIATION ***/
    /**
     * Construct new Javelin instance, including binding it to the store
     * Note that store isn't hydrated by instantiating JavelinImpl - it merely
     * gets bound in this step
     *
     * TODO determine if store binding actually required in JavelinImpl constructor
     */
    function JavelinImpl(appVersion, translateFn, languages) {
        if (languages === void 0) { languages = ["en", "fr"]; }
        /**
         * Returns UUID generated by the client
         * @return {string} Generated UUID string
         */
        this.randomId = function () { return react_1.uuid(); };
        /*** "DEVICE" DATA ***/
        this.deviceName = react_1.getUserAgentString(); // PLACEHOLDER
        // TODO inject deviceName, deviceModel, deviceId, platformVersion, or get them from window
        this.deviceId = "webclient-device-browser"; // PLACEHOLDER: `Chrome` || Alternative: uuid()
        this.deviceModel = react_1.osName() + " : " + react_1.osVersion() + " --- " +
            (react_1.browserEngineName() + " : " + react_1.browserEngineVersion() + " --- ") +
            (react_1.browserName() + " : " + react_1.browserVersion()); // PLACEHOLDER: `web`
        this.platformVersion = react_1.browserEngineName() + " : " + react_1.browserEngineVersion() + " --- " +
            (react_1.browserName() + " : " + react_1.browserVersion()); // PLACEHOLDER: `51.1.231`
        this.appVersion = appVersion;
        JavelinImpl.version = appVersion;
        this._languageStore = language_store_1.buildLanguageStore({ languages: languages, language: "en" });
        this.languages = this._languageStore.languages;
        this.translateFn = translateFn;
        // Hydrate javelin data storage props
        this.store = store_1.store;
    }
    Object.defineProperty(JavelinImpl.prototype, "store", {
        get: function () {
            if (this._jvlnStore)
                return this._jvlnStore;
        },
        set: function (_store) {
            this._jvlnStore = _store;
        },
        enumerable: true,
        configurable: true
    });
    // TODO Move JavelinImpl->getString into separate helper function / file
    /**
     * Gets a String from a given String Id and arguments, and interpolate.
     * @param stringId  The String Id. Turned into actual string by translation func (if set).
     * @param arguments The String arguments. These replace %s values in the string (OPTIONAL).
     * @return The corresponding String, with values inserted (each %s is replaced by an arg).
     */
    JavelinImpl.prototype.getString = function (stringId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        var fn = "JavelinImpl # getString ::";
        log.verbose(fn + " stringId (key to get): " + stringId + "  |  args[0]: " + (args && args[0]));
        // Translate the string ID, if a translation function is available
        var str = this.translateFn
            ? this.translateFn(javelin_exports_1.StringIds[stringId])
            : javelin_exports_1.StringIds[stringId];
        // Handle cases where Javelin passes args to getString as an array
        // rather than set of params.
        var cleanArgs = args;
        if (args && Array.isArray(args) && args.length === 1 && Array.isArray(args[0])) {
            cleanArgs = args[0];
        }
        log.silly(fn + " cleanArgs:", cleanArgs);
        // If no args given, return translated string (or ID) as-is
        if (cleanArgs.length === 0) {
            log.silly(fn + " Posttranslation str (ID or text) w no cleanArgs; ret as-is: " + str);
            return str;
        }
        // TODO figure out why we had to make that special case --\/
        // SPECIAL CASE: 2 or more args given, and stringId === `notification_is_overdue`
        if (cleanArgs.length > 1 && stringId === "notification_is_overdue") {
            return (_a = this.getString).call.apply(_a, [this,
                "notification_is_overdue_time"].concat(cleanArgs));
        }
        // If only 1 arg given, replace %s, %d, and %1$s (but not %2$s etc.) with given arg.
        if (cleanArgs.length === 1) {
            var itpl1Str = str.replace(/%(([sd])|(1\$s))/g, cleanArgs[0]);
            log.silly(fn + " Interpolated string w 1 arg. Final form (itpl1Str): " + itpl1Str);
            return itpl1Str;
        }
        // If 2+ cleanArgs given, replace each numbered tag in the string with
        // the numerically corresponding arg. Each `%1$s` gets replaced by the
        // 1st arg given, each %2$s by the 2nd, & so on.
        var idx = 0;
        var itplStr = str;
        while (idx < cleanArgs.length) {
            itplStr = itplStr.replace(new RegExp("%" + (idx + 1) + "\\$s", "g"), cleanArgs[idx]);
            idx++;
        }
        // Just in case, replace all %s with the first arg
        itplStr = itplStr.replace(/%s/g, cleanArgs[0]);
        log.verbose(fn + " Interpolated string w multiple cleanArgs: final form itplStr:", itplStr);
        return itplStr;
    };
    /*** BROADCASTING ***/
    JavelinImpl.prototype.simpleBroadcast = function (objectType, action, value) {
        var _this = this;
        logAction("simpleBroadcast", action, value, objectType, true);
        switch (action) {
            case javelin_exports_1.Action.CREATE:
            case javelin_exports_1.Action.UPDATE:
                switch (objectType) {
                    case javelin_exports_1.Type.Simple.LANGUAGE:
                        this._languageStore.setLanguage(value);
                        return null;
                    case javelin_exports_1.SyncType.Simple.LOCK:
                    case javelin_exports_1.SyncType.Simple.PASSWORD:
                    case javelin_exports_1.SyncType.Simple.TOKEN:
                        mobx_1.runInAction(function () { return (_this._jvlnStore[objectType.toLowerCase()] = value); });
                        return this._jvlnStore[objectType.toLowerCase()];
                    default:
                        return null;
                }
            case javelin_exports_1.Action.READ:
                switch (objectType) {
                    case javelin_exports_1.Type.Simple.LANGUAGE:
                        return this._languageStore.language;
                    // Return the matching type from the store: .lock, .password, or .token
                    case javelin_exports_1.SyncType.Simple.LOCK:
                    case javelin_exports_1.SyncType.Simple.PASSWORD:
                    case javelin_exports_1.SyncType.Simple.TOKEN:
                        return this._jvlnStore[objectType.toLowerCase()];
                    default:
                        return null;
                }
            case javelin_exports_1.Action.DELETE:
                switch (objectType) {
                    case javelin_exports_1.Type.Simple.LANGUAGE:
                        return this._languageStore.setLanguage(null);
                    case javelin_exports_1.SyncType.Simple.LOCK:
                        this.store.deleteLock();
                        return null;
                    case javelin_exports_1.SyncType.Simple.PASSWORD:
                        this.store.deletePassword();
                        return null;
                    case javelin_exports_1.SyncType.Simple.TOKEN:
                        this.store.deleteToken();
                        return null;
                    default:
                        return null;
                }
            case javelin_exports_1.Action.RECORD_FETCH:
                return null;
            case javelin_exports_1.Action.UI_UPDATE:
                return null;
            case javelin_exports_1.Action.REGENERATE_PAGES:
                return null;
            default:
                return null;
        }
    };
    // ******************************** LIFECYCLES *********************************
    // =============================================================================
    // DOSEBOX DOSE
    // ------------
    //    Unscheduled --> Received    << CREATE  | dose.receive
    //    Recommended --> Received    << CREATE  | dose.receive
    //    Scheduled   --> Received    << UPDATE  | dose.receive
    //    Received    --> Scheduled   << UPDATE  | dose.unreceive
    //
    // (action UI_UPDATE also called after each action above)
    //
    // NON-DOSEBOX DOSE
    // ----------------
    //    Unscheduled --> Scheduled   << CREATE  | dose.save
    //    Scheduled   --> Unscheduled << DELETE  | dose.save
    //    Scheduled   --> Received    << UPDATE  | dose.save
    //    Received    --> Scheduled   << UPDATE  | dose.save
    //    Received    --> Received    << UPDATE  | dose.save
    //
    // (action UI_UPDATE also called after each action above)
    //
    // save is what triggers a switch from one state to another
    //   - !!!!!! RECORD DOES NOT USE "ACTIVE RECORD" PATTERN !!!!!!
    //   - you must pass the changed properties to save
    //   - changes made by mutating values on the record directly are lost
    // =============================================================================
    // ********************************** ACTIONS **********************************
    // =============================================================================
    // CREATE
    // ------
    // Data object returned, store it in in-memory "db". Called:
    //     Every time a user interacts with a dose object for the first time. e.g.:
    //         - a dose goes from recommended -> received
    //         - a dose gets marked `scheduled`
    //     On creation of a record
    //
    // UPDATE
    // ------
    // Data object returned, overwrite value already in in-memory "db". Called:
    //     Every time a record is updated (i.e. any property changes)
    //     Every time a user interacts with an existing dose object
    //         i.e. every time an already-existing dose gets modified
    //
    // UI_UPDATE
    // ---------
    // @TODO consider implementing this
    // In-memory obj refetches data from DB, UI updates. Returns recordId. Called:
    //     Every time a record is updated
    //     Every time a user interacts with an existing dose
    //     Any time any user information is changed
    //
    // DELETE
    // ------
    // Removes object from in-memory DB. Called:
    //     A dose gets unscheduled
    //     A record gets deleted
    //
    // REGENERATE_PAGES
    // ----------------
    // Tells client when it should regenerate its Pages & update its UI
    //
    // RECORD_FETCH
    // ------------
    // In-memory object refetches data from DB, without UI update
    //
    // READ :: Definitely YAGNI. Gets data (?)
    // =============================================================================
    JavelinImpl.prototype.broadcast = function (action, obj) {
        var fn = "JavelinImpl # broadcast:";
        logAction("broadcast", action, obj);
        switch (action) {
            case "LOCK":
                this._jvlnStore.jvlnsBroadcaster.emitBroadcast("ev_LOGOUT", { action: action, obj: obj });
                break;
            case javelin_exports_1.Action.UPDATE:
            case javelin_exports_1.Action.CREATE:
                if (obj instanceof javelin_exports_1.Record) {
                    this.store.addOrUpdateRecord(obj);
                }
                else if (obj instanceof javelin_exports_1.Dose) {
                    this.store.doseStore.addOrUpdateDose(obj, action);
                }
                else if (obj instanceof javelin_exports_1.Transaction) {
                    // This is a temporary fix for a bug that we don't want to spend time tracking
                    // down right now, and this is sufficient if a rebuild is in the works
                    if (obj.objectType === 2 && obj.action !== 2) {
                        obj.newValue = JSON.stringify(__assign({}, JSON.parse(obj.newValue), { phuConfig: undefined }));
                    }
                    this.store.addTransactions(obj);
                }
                else if (isAccountData(obj)) {
                    this.store.setAccount(obj);
                }
                break;
            case javelin_exports_1.Action.DELETE:
                if (obj instanceof javelin_exports_1.Transaction) {
                    this.store.deleteTransaction(obj);
                }
                else if (obj instanceof javelin_exports_1.Record) {
                    store_1.store.jvlnsBroadcaster.emitBroadcast("ev_DELETE_RECORD", obj);
                    this.store.deleteRecord(obj);
                }
                else if (obj instanceof javelin_exports_1.Dose) {
                    this.store.doseStore.deleteDose(obj);
                    log.info("DELETED Dose:", obj, "\n..from doseStore:", this.store.doseStore);
                }
                break;
            case javelin_exports_1.Action.RECORD_FETCH:
                log.info("JavelinImpl#broadcast: Action.RECORD_FETCH:", action, "\nobj:", obj);
                this.store.jvlnsBroadcaster.emitBroadcast("ev_REGENERATE_PAGES", obj);
                break;
            case javelin_exports_1.Action.REGENERATE_PAGES:
                log.info("JavelinImpl#broadcast: Action.REGENERATE_PAGES:", action, "\nobj:", obj);
                this.store.jvlnsBroadcaster.emitBroadcast("ev_REGENERATE_PAGES", obj);
                break;
            case javelin_exports_1.Action.UI_UPDATE:
            case javelin_exports_1.Action.READ:
            default:
                break;
        }
    };
    /*** LOGGING ***/
    /**
     * Logs debug information to the console
     * @param tag     Log tag
     * @param message Log message
     */
    JavelinImpl.prototype.logMessage = function (tag, message) {
        log.info("JavelinImpl # log -- TAG " + tag + " -- " + message);
    };
    /**
     * Logs an error to the console (Any custom message will be within the [Throwable])
     * @param tag       Log tag
     * @param exception Caught [Throwable]
     */
    JavelinImpl.prototype.logError = function (tag, exception) {
        log.error("JavelinImpl # log -- TAG " + tag + " ::\n" + "** Error type: (below) **\n", exception.name + "\n" + "** Error message: (below) **\n", exception.message + "\n" + "** Stack: (below) **\n", "" + exception.stack);
    };
    /**
     * Implementation of log (for all allowed param types)
     */
    JavelinImpl.prototype.log = function (tag, msgOrErr) {
        if (typeof msgOrErr === "string") {
            this.logMessage(tag, msgOrErr);
        }
        else {
            this.logError(tag, msgOrErr);
        }
    };
    JavelinImpl.version = "";
    return JavelinImpl;
}());
exports.JavelinImpl = JavelinImpl;
/******************************************** HELPERS *********************************************/
// Convenience strings
var blankLns3 = react_1.repeatChars("\n", 3);
var bookend = ["%c" + react_1.repeatChars("-", 80), "color:magenta;"];
/**
 * Log a broadcasted action
 */
function logAction(fn, action, val, objectType, simple) {
    if (simple === void 0) { simple = false; }
    var magenta = "color: magenta;";
    var black = "color: black;";
    var green = "color: green;";
    // prettier-ignore
    var actionType = react_1.switchExpr(action === javelin_exports_1.Action.CREATE, "CREATE", action === javelin_exports_1.Action.DELETE, "DELETE", action === javelin_exports_1.Action.READ, "READ", action === javelin_exports_1.Action.RECORD_FETCH, "RECORD_FETCH", action === javelin_exports_1.Action.UI_UPDATE, "UI_UPDATE", action === javelin_exports_1.Action.UPDATE, "UPDATE", "UNKNOWN (action arg value: " + action);
    console.log(blankLns3);
    console.log("%c" + (simple ? "--------------------" : "-------------"), magenta);
    console.log("%c| %c" + (simple ? "SIMPLE_BROADCAST" : "BROADCAST") + " %c|", magenta, black, magenta);
    console.log.apply(console, bookend);
    console.log("%cORIGINATING FUNCTION", green, "       :: " + fn + "\n");
    console.log("%cACTION TYPE", green, "                :: " + action + "\n");
    if (typeof objectType !== "undefined" || simple === true) {
        console.log("%cOBJECT TYPE", green, "                :: " + objectType + "\n");
    }
    console.log("%cOBJECT/VALUE GIVEN (val)", green, "   :: (below)", val);
    console.log.apply(console, bookend);
    console.log(blankLns3);
}
/**
 * Returns true if given object is account data
 */
function isAccountData(obj) {
    var oKeys = keys(obj);
    return !!(obj.accountId &&
        obj.email &&
        obj.lastSyncTimestamp &&
        obj.name &&
        oKeys.find(function (key) { return key === "phone"; }) &&
        oKeys.find(function (key) { return key === "isPhoneVerified"; }) &&
        oKeys.find(function (key) { return key === "isMFAEnabled"; }) &&
        oKeys.find(function (key) { return key === "isPushEnabled"; }));
}
//# sourceMappingURL=javelin-impl.js.map